// admin/src/pages/Analytics/Analytics.jsx
import React from "react";
import { Typography, Box, Paper, useMediaQuery, useTheme } from "@mui/material";
import { Analytics as AnalyticsIcon } from "@mui/icons-material";

const Analytics = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <Paper
        sx={{
          p: 3,
          background: "linear-gradient(135deg, #1a237e, #3949ab)",
          color: "white",
        }}
      >
        <Box 
          display="flex" 
          flexDirection={{ xs: "column", md: "row" }} 
          alignItems={{ xs: "flex-start", md: "center" }} 
          gap={3}
        >
          <AnalyticsIcon sx={{ fontSize: isMobile ? 50 : 80 }} />
          <Box>
            <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold">
              Advanced Analytics
            </Typography>
            <Typography variant={isMobile ? "body1" : "h6"} sx={{ opacity: 0.9 }}>
              Data insights & reporting
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Analytics;
